module.exports = __webpack_public_path__ + "img/women's_activewear.00ac238e.svg";